// /settings — per-category notification toggles. Critical alerts can't be
// disabled (privacy/safety baseline); the rest are user-controlled.

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Section, Cell, List, Caption, Spinner, Banner, Switch,
} from "@telegram-apps/telegram-ui";
import { api } from "../lib/api.js";
import { usePageBack } from "../lib/telegram.js";

const CATS = [
  {
    key: "critical",
    label: "🟥 Срочные",
    sub: "Поле закрыто, ваш слот отменён, опасные изменения в небе. Всегда включено.",
    locked: true,
  },
  {
    key: "confirm",
    label: "🟨 Подтверждения",
    sub: "Админ просит подтвердить полёт; конфликт слотов и т.п. — с inline-кнопками.",
  },
  {
    key: "digest",
    label: "🟩 Утренняя сводка",
    sub: "Несрочные новости одним сообщением в 07:00.",
  },
  {
    key: "admin_announcements",
    label: "📣 Объявления админа",
    sub: "Анонсы аэродромов, на которых вы летаете.",
  },
  {
    key: "marketing",
    label: "✨ Новости проекта",
    sub: "Обновления Mini App, опросы. По умолчанию выключено.",
  },
];

export default function Settings() {
  const navigate = useNavigate();
  usePageBack("/");
  const [prefs, setPrefs] = useState(null);
  const [error, setError] = useState(null);
  const [pendingKey, setPendingKey] = useState(null);

  useEffect(() => {
    api("/api/v1/me/notification-prefs")
      .then((r) => setPrefs(r.prefs))
      .catch((e) => setError(`Не удалось загрузить настройки: ${e.message}`));
  }, []);

  async function toggle(key) {
    if (!prefs) return;
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    setPendingKey(key);
    try {
      const r = await api("/api/v1/me/notification-prefs", {
        method: "PATCH",
        body: JSON.stringify({ [key]: next[key] }),
      });
      setPrefs(r.prefs);
    } catch (e) {
      setError(e.message || "Не удалось сохранить.");
      setPrefs((p) => ({ ...p, [key]: !next[key] })); // rollback
    } finally {
      setPendingKey(null);
    }
  }

  if (error && !prefs) return <List><Banner type="section" header="Ошибка">{error}</Banner></List>;
  if (!prefs) return <List><Section><Cell before={<Spinner size="m" />}>Загружаем…</Cell></Section></List>;

  return (
    <List>
      {error && <Banner type="section" header="Ошибка">{error}</Banner>}
      <Section header="Уведомления">
        {CATS.map((c) => (
          <Cell
            key={c.key}
            subtitle={c.sub}
            multiline
            after={
              <Switch
                checked={prefs[c.key] !== false}
                disabled={c.locked || pendingKey === c.key}
                onChange={() => !c.locked && toggle(c.key)}
              />
            }
          >
            {c.label}
          </Cell>
        ))}
      </Section>
      <Section>
        <Cell>
          <Caption level="1">
            Срочные оповещения нельзя выключить — без них вы можете пропустить отмену слота или закрытие аэродрома.
          </Caption>
        </Cell>
        <Cell onClick={() => navigate("/")}>← На главную</Cell>
      </Section>
    </List>
  );
}
